import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=563ab890&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563ab890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('563ab890')) {
      api.createRecord('563ab890', component.options)
    } else {
      api.reload('563ab890', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=563ab890&scoped=true&", function () {
      api.rerender('563ab890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FjZvep5eBrPq/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports